<div *ngIf="booking" class="panel panel-default">
  <!--  <div class="panel-heading">
    <label>{{'BOOKING_DETAILS'|translate}}</label>
  </div>-->
  <div class="panel-body">
    <table class="table">
      <tr>
        <td>{{ 'SHOP' | translate }}</td>
        <!--TODO: Link to shop details-->
        <td>{{ booking.shopName }}</td>
      </tr>
      <tr>
        <td>{{ 'ADDRESS' | translate }}</td>
        <td>
          <!-- <td *ngIf="booking.paymentMethodId"> -->
          <a
            id="viewGoogleMapsBooking"
            [href]="shop | mapsLink: true"
            target="_blank"
            angulartics2On="click"
            angularticsAction="ViewGoogleMapsBooking"
            [angularticsCategory]="booking.address.countryCode"
            [angularticsLabel]="booking.shopName"
          >
            {{ booking.address.formattedAddress }}
          </a>
        </td>
        <!-- <td *ngIf="!booking.paymentMethodId">
          {{ 'DIRECTIONS_AFTER_PAYMENT_INFO' | translate }}
        </td> -->
      </tr>
      <!--<tr *ngIf="!isCheckedIn">
        <td>{{ 'EXPECTED_DROP_OFF' | translate }}</td>
        <td>{{ booking.period.from | lhMoment:'localeDateTime' }}</td>
      </tr>-->
      <tr *ngIf="!isCheckedOut">
        <td>{{ 'OPENING_HOURS' | translate }}</td>
        <td>{{ weekday }} {{ openingHours | timeInterval | async }}</td>
      </tr>
      <tr *ngIf="isCheckedIn">
        <td>{{ 'CHECKED_IN' | translate }}</td>
        <td>{{ booking.period.checkIn | lhMoment: 'localeDateTime' }}</td>
      </tr>
      <tr *ngIf="isCheckedOut">
        <td>{{ 'CHECKED_OUT' | translate }}</td>
        <td>{{ booking.period.checkOut | lhMoment: 'localeDateTime' }}</td>
      </tr>
      <tr>
        <td>{{ 'BAGS' | translate }}</td>
        <td>{{ booking.luggage.normal + booking.luggage.hand }}</td>
      </tr>
      <tr *ngIf="booking.price.final">
        <td>{{ 'FINAL_PRICE' | translate }}</td>
        <td>&euro; {{ booking.price.final.total }}</td>
      </tr>
      <tr *ngIf="booking.price.discountCode">
        <td>{{ 'DISCOUNT_CODE' | translate }}</td>
        <td>
          "{{ booking.price.discountCode }}"
          <span *ngIf="booking.price.estimated.discount === 0">({{ 'INVALID' | translate }})</span>
          <span *ngIf="booking.price.estimated.discount > 0">({{ 'VALID' | translate }})</span>
        </td>
      </tr>
      <tr>
        <td></td>
        <td></td>
      </tr>
    </table>

    <div *ngIf="!booking.paymentMethodId" class="text-center">
      <strong class="text-warning">{{ 'NO_PAYMENT_METHOD_SELECTED' | translate }}</strong>
    </div>
  </div>
</div>
<div *ngIf="!booking">
  <b>{{ 'NO_BOOKING_FOUND' | translate }}</b>
</div>
